export default __webpack_public_path__ + "static/media/tom-ford.6f4ee862.jpg";